import { Theme, css } from '@emotion/react';

export const dialogTitleStyles = ({ spacing }: Theme) => css`
  padding: ${spacing(3)}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const dialogTitleText = ({ spacing }: Theme) => css`
  padding-right: ${spacing(4)}px;
`;

export const dialogTitleButton = ({ colors }: Theme) => css`
  color: ${colors.fgDefault};
`;
